import api, { unwrap } from './client';
import type { ApiResponse } from '@/types/api';
import type { ProjectClientPortalDashboard, ProjectTask } from '@/types/projects';

export interface PortalDocument {
  id: number;
  fileName: string;
  fileUrl: string;
  mimeType?: string;
}

export interface ProjectPortalAuthResponse {
  accessToken: string;
  organizationId: number;
  projectId: number;
  customerId: number;
  email: string;
}

const PORTAL_TOKEN_KEY = 'projects_portal_token';

export const projectsPortalApi = {
  setToken: (token: string) => localStorage.setItem(PORTAL_TOKEN_KEY, token),
  getToken: () => localStorage.getItem(PORTAL_TOKEN_KEY),
  clearToken: () => localStorage.removeItem(PORTAL_TOKEN_KEY),

  requestLink: (organizationId: number, email: string) =>
    unwrap(api.post<ApiResponse<void>>('/v1/projects-portal/auth/request-link', { organizationId, email })),

  verify: (token: string) =>
    unwrap(api.post<ApiResponse<ProjectPortalAuthResponse>>('/v1/projects-portal/auth/verify', { token })),

  dashboard: () =>
    unwrap(
      api.get<ApiResponse<ProjectClientPortalDashboard>>('/v1/projects-portal/dashboard', {
        headers: { Authorization: `Bearer ${projectsPortalApi.getToken()}` },
      }),
    ),

  tasks: () =>
    unwrap(
      api.get<ApiResponse<ProjectTask[]>>('/v1/projects-portal/tasks', {
        headers: { Authorization: `Bearer ${projectsPortalApi.getToken()}` },
      }),
    ),

  documents: () =>
    unwrap(
      api.get<ApiResponse<PortalDocument[]>>('/v1/projects-portal/documents', {
        headers: { Authorization: `Bearer ${projectsPortalApi.getToken()}` },
      }),
    ),

  invoices: () =>
    unwrap(
      api.get<ApiResponse<import('@/types/projects').PortalInvoice[]>>('/v1/projects-portal/invoices', {
        headers: { Authorization: `Bearer ${projectsPortalApi.getToken()}` },
      }),
    ),
};
